import { DialogWithActions, DialogWithActionsProps, ServiceTimeSlotVariationEditor } from "..";

export interface ServiceTimeSlotVariationDialogProps extends Omit<DialogWithActionsProps, 'fullScreen'> {
  serviceId: string;
  date: Date;
}

export function ServiceTimeSlotVariationDialog(
  props: ServiceTimeSlotVariationDialogProps
) {
  const { date, serviceId, setOpen, ...dialogProps } = props;

  return (
    <DialogWithActions
      fullScreen={true}
      setOpen={setOpen}
      {...dialogProps}
      actions={[]}
    >
      <ServiceTimeSlotVariationEditor 
        key={`${date.toLocaleString()}-${serviceId}`}
        date={date} 
        serviceId={serviceId} 
      />
    </DialogWithActions>
  )
}